import * as ng from 'angular';
import * as _ from 'underscore';
import * as Highcharts from 'highcharts';

import {Dataset} from '..';

ng.module('e360')
   .factory('gaugeChartFactory', gaugeChartFactory);

gaugeChartFactory.$inject = ['instanceServiceFactory'];
function gaugeChartFactory(instanceServiceFactory) {
   return instanceServiceFactory(GaugeChart);
}

// Requires that object data has properties named current and total
export class GaugeChart {
   static $inject = ['ds'];

   chart:Highcharts.ChartObject;

   constructor(ds:Dataset) {
      let options = {
         exporting: { enabled: false },
         credits: { enabled: false },
         tooltip: { enabled: false },
         chart: {
            renderTo: ds.id,
            type: 'solidgauge'
         },
         title: {
            text: ds.title
         },
         pane: {
            center: ['50%', '60%'],
            size: '120%',
            startAngle: -120,
            endAngle: 120,
            background: {
               backgroundColor: '#f1f1f1',
               innerRadius: '60%',
               outerRadius: '100%',
               shape: 'arc',
               borderWidth: 0
            }
         },
         yAxis: {
            stops: [
               [0.1, '#3CB4E5'],
               [0.9, '#E353A9']
            ],
            lineWidth: 0, // remove outer border
            tickAmount: 2,
            minorTickInterval: null,  // hide ticks
            tickColor: 'transparent', // ^
            labels: {
               distance: -25,
               y: 15,
               style: {
                  fontSize: '14px',
               }
            }
         },
         plotOptions: {
            solidgauge: {
               // count displayed in center of gauge
               dataLabels: {
                  borderWidth: 0,
                  style: {
                     fontSize: '24px'
                  }
               }
            }
         },
         series: [{
            name: ds.title
         }]
      };

      this.chart = new Highcharts.Chart(options);
   }

   setData(data:any[]) {
      // changing tickInterval based on axis max was needed to avoid
      // highcharts chaining/rounding the max
      this.chart.yAxis[0].update({tickInterval: data[0].total/256});
      this.chart.yAxis[0].setExtremes(0, data[0].total);
      this.chart.series[0].setData([data[0].current]);
   }

   setGaugeMinAndMax(min:number = 0, max:number = 100, redraw:boolean = true) {
      this.chart.yAxis[0].update({tickInterval: max/256}, redraw);
      this.chart.yAxis[0].setExtremes(min, max);
   }

   setCurrent(current:number, redraw:boolean = true, animation:boolean = true) {
      this.chart.series[0].setData([current], redraw, animation);
   }

   setColors(colors:string[]) {
      this.chart.options.yAxis[0].stops = [
         [0.1, colors[1]],
         [0.9, colors[2]]
      ];
   }

   onLoadStart() {
      this.chart.showLoading();
   }

   onLoadFinish() {
      this.chart.hideLoading();
   }
}

export interface GaugeChartFactory {
   ({ds:Dataset}):GaugeChart;
}
